var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBar)?_c('div',[_c('span',{on:{"click":_vm.closeBar}},[_vm._v("×")]),_vm._v(" We collect cookies in order to improve your experience. "),_c('a',{attrs:{"href":"https://tools.google.com/dlpage/gaoptout?hl=en"}},[_vm._v("Click here")]),_vm._v(" if you would not like to receive these cookies. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }